"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbFullLayout = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sbLayout = require("../sb-layout");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * @description
 * The three column layout
 * @name skybase-components.layouts.sb-full-layout.sb-full-layout#Sb12Layout
 * @function
 *
 * @param {skybase-components.layouts.sb-full-layout.sb-full-layout#props} props
 * @return {React.Component}
 */
var SbFullLayout = function SbFullLayout(props) {
  return /*#__PURE__*/_react.default.createElement(_sbLayout.SbLayout, _extends({}, props, {
    layoutType: _constants.LayoutFull
  }));
};
/**
 * @typedef skybase-components.layouts.sb-full-layout.sb-full-layout#props
 *
 * @property {React.Component} children
 */


exports.SbFullLayout = SbFullLayout;
SbFullLayout.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]).isRequired
};
//# sourceMappingURL=sb-full-layout.js.map